var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(JSON.stringify(_vm.data, null, 4)))])
}
var staticRenderFns = []

export { render, staticRenderFns }